import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'App';
import { joinClassroom } from 'api/userApi';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, FormControl, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const StartCard = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  isFeatured,
  features,
  isJoin = false
}) => {
  const [classroomCode, setClassroomCode] = useState('');

  const handleClassroomCode = e => {
    // classroom code should only contains letters and numbers
    const value = e.target.value;
    if (/[^a-zA-Z0-9]/.test(value)) {
      e.target.value = value.replace(/[^a-zA-Z0-9]/g, '');
    }
    setClassroomCode(e.target.value.toUpperCase());
  };

  const mutation = useMutation({
    mutationFn: joinClassroom,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['userData'] });
      toast.success(() => (
        <span>
          Sei entrato nella classe
          <br />
          <strong>{data.name}</strong>!
        </span>
      ));
      window.location.reload();
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    }
  });

  const handleSubmit = e => {
    e.preventDefault();
    mutation.mutate({
      classroomCode: classroomCode
    });
  };

  return (
    <Col md>
      <div className="border rounded-3 overflow-hidden mb-3 mb-md-0">
        <Flex justifyContent="between" alignItems="center" className="p-4">
          <div>
            <h3 className="fw-light fs-4 mb-0 text-primary text-center">
              <strong>{title}</strong>
            </h3>
            <h5 className="fw-light mt-4 text-center">{subtitle}</h5>
          </div>
        </Flex>
        <div className="p-4 bg-body-tertiary">
          <ul className="list-unstyled">
            {features?.map((feature, index) => (
              <li className="border-bottom py-2" key={index}>
                <FontAwesomeIcon
                  icon="check"
                  className="text-primary me-2"
                  transform="shrink-2"
                />{' '}
                {feature}
              </li>
            ))}
          </ul>
          {isJoin ? (
            <InputGroup>
              <FormControl
                placeholder="Codice classe"
                aria-label="Codice classe"
                value={classroomCode}
                onChange={e => handleClassroomCode(e)}
                maxLength={6}
              />
              <Button
                variant="outline-primary"
                onClick={handleSubmit}
                disabled={classroomCode.length != 6}
              >
                Entra
              </Button>
            </InputGroup>
          ) : (
            <Link to={buttonLink}>
              <Button
                variant={isFeatured ? 'primary' : 'outline-primary'}
                className="d-block w-100"
              >
                {buttonText}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </Col>
  );
};

StartCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.element,
  isFeatured: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
  features: PropTypes.array,
  isJoin: PropTypes.bool
};

export default StartCard;
